"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledReviewsSummary = exports.StyledReviewsStars = exports.StyledReviewsCount = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var _default = {};
exports["default"] = _default;

var StyledReviewsSummary = _styledComponents["default"].section.withConfig({
  displayName: "ProductReviewsstyles__StyledReviewsSummary",
  componentId: "sc-6b7ez1-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["w-100 flex flex-wrap tc pv4"]))));

exports.StyledReviewsSummary = StyledReviewsSummary;

var StyledReviewsCount = _styledComponents["default"].section.withConfig({
  displayName: "ProductReviewsstyles__StyledReviewsCount",
  componentId: "sc-6b7ez1-1"
})(["", " & > span{", "}"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["w-100 f4 pb1"]))), (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["b"]))));

exports.StyledReviewsCount = StyledReviewsCount;

var StyledReviewsStars = _styledComponents["default"].section.withConfig({
  displayName: "ProductReviewsstyles__StyledReviewsStars",
  componentId: "sc-6b7ez1-2"
})(["", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["w-100 f4 orange"]))));

exports.StyledReviewsStars = StyledReviewsStars;